module.exports = "<div class=\"subscription-modal-content\"><serp-subscribe email=\"{$ email $}\" card-title=\"'Подпишитесь на новые объявления'\" text=\"Мы будем присылать вам на почту все новые предложения по этому запросу\" deal-type=\"{$ dealType $}\" search-title=\"{$ searchTitle $}\" url=\"{$ url $}\" ga-label=\"From_cat_popup_Resale\"></serp-subscribe></div>"


//////////////////
// WEBPACK FOOTER
// ./src/serp/directives/subscription-modal/subscription-modal.jade
// module id = 1030
// module chunks = 0